import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { GraphicStoragePage, GraphicStorageDetailPage }  from "components/pages/graphic-storage";


export default function GraphicStorageRoute() {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }` } exact>
                <GraphicStoragePage />
            </Route>
            <Route path={ `${ path }/page/:pageNum` } exact>
                <GraphicStoragePage />
            </Route>
            <Route path={ `${ path }/:gsID` } >
                { ({ match, history }) => <GraphicStorageDetailPage match={ match } history={ history } exact /> }
            </Route>
            <Route path={ `${ path }/create` } exact>
                <GraphicStorageDetailPage />
            </Route>
        </Switch>
    );
}
